import { SettingsCache } from '~/lib/consts/settings-cache';
import { ProtectionExtraIds } from '../../components/ExtrasHelper';
import { SmartSendProvider } from '~/lib/consts/providers';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';

export function ProtectionIsEnabledForService(service: { Provider: string }) {
  // Only supported by P2G Services, not Carrier Accounts.
  return SettingsCache.settings.Features.includes('Protection') && service?.Provider === SmartSendProvider;
}

export function ProtectionIsEnabled({ MarketplaceStatus, Status, State, Service }: SmartSendItemApiModel) {
  return Boolean(
    MarketplaceStatus == 'Sold' &&
      Status == 'Active' &&
      ProtectionIsEnabledForService(Service) &&
      State?.validation?.QuoteState?.Quote?.Options[0] &&
      (State?.validation?.QuoteState?.Quote?.Options[0].AvailableExtras.find((a) =>
        ProtectionExtraIds.includes(a.Id)
      ) ||
        State?.validation?.QuoteState?.Quote?.Options[0].Extras.find((a) => ProtectionExtraIds.includes(a.Id)))
  );
}
